<template>
  <div class="sidebar">
    <div class="content">
      <div
        class="title1 flex flex-ac pointer"
        @click="$router.push({ path: '/' })"
      >
        {{ $t('sidebar.home') }}
        <div class="iconfont icon-iconleft ml-auto iconleft"></div>
      </div>
      <div class="line"></div>
      <div>
        <div class="title1">{{ $t('sidebar.accountManagement') }}</div>
        <div
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click.stop="changeitem(item, $event)"
        >
          <div
            class="item_title flex flex-ac"
            :class="active == item.name && 'item_title_ac'"
          >
            <span
              class="iconfont"
              :class="[
                active == item.name ? `active ${item.active}` : item.src,
              ]"
            ></span>
            <span :class="active == item.name ? 'active' : ''">{{
              item.title
            }}</span>

            <div class="iconfont icon-iconleft1 ml-auto iconleft1"></div>
            <div
              class="iconfont icon-iconleft1 ml-auto iconleft"
              v-if="active == item.name"
            ></div>
            <div class="iconfont icon-iconleft ml-auto iconleft" v-else></div>
          </div>
          <div
            v-if="item.children.length > 0"
            class="children"
            :class="item.active ? 'children_active' : ''"
            @click.stop=""
          >
            <div
              class="children_item"
              :ga-data="c.gadata"
              v-for="(c, i) in item.children"
              :key="i"
              @click.stop="changechildren(c)"
            >
              <span
                class="iconfont"
                :ga-data="c.gadata"
                :class="[c.src, c.active ? 'children_item_active' : '']"
              ></span>
              <span
                :class="c.active ? 'children_item_active' : ''"
                :ga-data="c.gadata"
                >{{ c.title }}</span
              >
            </div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div v-if="userInfo?.vip_status != 'inactive_affiliate' || false">
        <div class="title1">{{ $t('sidebar.memberManagement') }}</div>
        <div
          class="item"
          v-for="(item, index) in list1"
          :key="index"
          @click.stop="changeitem(item, $event)"
        >
          <div
            class="item_title flex flex-ac"
            :class="mapitme(item) && 'item_title_ac'"
          >
            <span
              class="iconfont"
              :class="[mapitme(item) ? `active ${item.active}` : item.src]"
            ></span>
            <span :class="active == item.name ? 'active' : ''">{{
              item.title
            }}</span>
            <div class="iconfont icon-iconleft ml-auto iconleft"></div>
            <div class="iconfont icon-iconleft1 ml-auto iconleft1"></div>
          </div>
          <div
            v-if="item.children.length > 0"
            class="children"
            :class="mapitme(item) ? 'children_active' : ''"
            @click.stop=""
          >
            <div
              class="children_item"
              :class="active == c.name ? 'children_item_active' : ''"
              v-for="(c, i) in item.children"
              :key="i"
              @click.stop="changechildren(c)"
            >
              <div
                :class="
                  active == c.name
                    ? 'children_item_icon children_item_icon_ac'
                    : 'children_item_icon'
                "
              ></div>
              <span :class="active == c.name ? 'text-B4926E' : 'text-666'">{{
                c.title
              }}</span>
            </div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div>
        <div class="title1">{{ $t('sidebar.menu') }}</div>
        <div
          class="item"
          v-for="(item, index) in list2"
          :key="index"
          @click.stop="changeitem(item, $event)"
        >
          <div
            class="item_title flex flex-ac"
            :class="mapitme(item) && 'item_title_ac'"
          >
            <span
              class="iconfont"
              :class="[mapitme(item) ? `active ${item.active}` : item.src]"
            ></span>
            <span :class="active == item.name ? 'active' : ''">{{
              item.title
            }}</span>
            <div class="iconfont icon-iconleft ml-auto iconleft"></div>
            <div class="iconfont icon-iconleft1 ml-auto iconleft1"></div>
          </div>
          <div
            v-if="item.children.length > 0"
            class="children"
            :class="mapitme(item) ? 'children_active' : ''"
            @click.stop=""
          >
            <div
              class="children_item"
              :class="active == c.name ? 'children_item_active' : ''"
              v-for="(c, i) in item.children"
              :key="i"
              @click.stop="changechildren(c)"
            >
              <div
                :class="
                  active == c.name
                    ? 'children_item_icon children_item_icon_ac'
                    : 'children_item_icon'
                "
              ></div>
              <span :class="active == c.name ? 'text-B4926E' : 'text-666'">{{
                c.title
              }}</span>
            </div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="title1 flex flex-ac pointer logout" @click="loginout">
        {{ $t('sidebar.logout') }}
        <div class="iconfont icon-iconleft ml-auto iconleft"></div>
        <div class="iconfont icon-iconleft1 ml-auto iconleft1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      active: null,
      list: [
        {
          title: this.$t('sidebar.accountInfo'),
          src: 'icon-icon4',
          active: 'icon-icon4-ac',
          name: 'accountInfo',
          path: '/accountInfo',
          children: [],
        },
        // {
        //   title: this.$t('sidebar.changePassword'),
        //   src: 'icon-icon5',
        //   active: 'icon-icon5-ac',
        //   name: 'changepassword',
        //   path: '/changepassword',
        //   children: [],
        // },
        // {
        //   title: this.$t('sidebar.bindPhone'),
        //   src: 'icon-icon6',
        //   active: 'icon-icon6-ac',
        //   name: 'bindphone',
        //   path: '/bindphone',
        //   children: [],
        // },
        // {
        //   title: this.$t('sidebar.viewLoginRecords'),
        //   src: 'icon-icon7',
        //   active: 'icon-icon7-ac',
        //   name: 'loginRecord',
        //   path: '/loginRecord',
        //   children: [],
        // },
      ],
      list1: [
        {
          title: this.$t('sidebar.purchasePackage'),
          src: 'icon-icon13',
          active: 'icon-icon13-ac',
          name: 'purchasemeal',
          path: '/purchasemeal',
          children: [
            {
              title: this.$t('sidebar.selectPackage'),
              name: 'purchasemeal',
              path: '/purchasemeal',
            },
            // {
            //   title: this.$t('sidebar.memberBenefitsDescription'),
            //   name: 'memberexplain',
            //   path: '/memberexplain',
            // },
            // {
            //   title: this.$t('sidebar.purchaseRecords'),
            //   name: 'purchasehistory',
            //   path: '/purchasehistory',
            // },
            {
              title: this.$t('sidebar.memberpointsdetail'),
              name: 'memberpointsdetail',
              path: '/memberpointsdetail',
            },
            {
              title: this.$t('sidebar.shop'),
              name: 'shop',
              path: 'https://www.hisynergy.shop/',
            },
            {
              title: this.$t('productintroduce.productIntroduction'),
              name: 'productintroduce',
              path: '/productintroduce',
            },
          ],
        },
        {
          title: this.$t('sidebar.memberPersonalInfo'),
          src: 'icon-icon8',
          active: 'icon-icon8-ac',
          name: 'memberinfo',
          path: '/memberinfo',
          children: [],
        },
        // {
        //   title: this.$t('sidebar.referrerInfo'),
        //   src: 'icon-icon9',
        //   active: 'icon-icon9-ac',
        //   name: 'referrerinfo',
        //   path: '/referrerinfo',
        //   children: [],
        // },
        {
          title: this.$t('sidebar.myteam'),
          src: 'icon-icon10',
          active: 'icon-icon10-ac',
          select: 'tree',
          name: 'tree',
          path: '/tree',
          children: [
            {
              title: this.$t('sidebar.teamStructure'),
              name: 'tree',
              path: '/tree',
            },
            {
              title: this.$t('LTP10.title'),
              name: 'LTP10',
              path: '/LTP10',
            },
            {
              title: this.$t('sidebar.lowerMemberData'),
              name: 'lowermemberdata',
              path: '/lowermemberdata',
            },
          ],
        },
        // {
        //   title: this.$t('sidebar.memberVipStatus'),
        //   src: 'icon-icon11',
        //   active: 'icon-icon11-ac',
        //   name: 'memberstatus',
        //   path: '/memberstatus',
        //   children: [],
        // },
      ],
      list2: [
        {
          title: this.$t('sidebar.bonusManagement'),
          src: 'icon-icon12',
          active: 'icon-icon12-ac',
          name: 'incomedetails',
          path: '/incomedetails',
          children: [
            {
              title: this.$t('sidebar.incomeDetails'),
              name: 'incomedetails',
              path: '/incomedetails',
            },
            {
              title: this.$t('sidebar.eWallet'),
              name: 'ewallet',
              path: '/ewallet',
            },
          ],
        },

        {
          title: this.$t('sidebar.orderManagement'),
          src: 'icon-icon14',
          active: 'icon-icon14-ac',
          name: 'order',
          path: '/order',
          children: [],
        },
        {
          title: this.$t('sidebar.pointsSystem'),
          src: 'icon-icon15',
          active: 'icon-icon15-ac',
          name: 'points_RP',
          path: '/points_RP',
          query: 1,
          children: [
            {
              title: 'RP',
              name: 'points_RP',
              path: '/points_RP',
              query: 1,
            },
            {
              title: 'GP',
              name: 'points_HP',
              path: '/points_HP',
              query: 2,
            },
            {
              title: this.$t('sidebar.myVouchers'),
              name: 'exchangecode',
              path: '/exchangecode',
            },
          ],
        },
        {
          title: this.$t('sidebar.messageNotifications'),
          src: 'icon-icon16',
          active: 'icon-icon16-ac',
          name: 'notify',
          path: '/notify',
          children: [],
        },
      ],
    }
  },
  watch: {
    '$route.path': 'updateActiveItem',
  },
  created() {
    // this.updateActiveItem()
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        this.active = this.$route.name
        this.$nextTick((res) => {
          document.querySelectorAll('.children').forEach((element, index) => {
            element.style.maxHeight = null
          })
          let panel = document.querySelectorAll('.children_active')[0]
          if (panel) {
            panel.style.maxHeight = panel.scrollHeight + 'px'
          }
        })
        this.$forceUpdate()
      })
    },
    loginout() {
      this.$confirm(this.$t('message.loginout'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning',
        customClass: 'out-model',
      })
        .then(() => {
          this.$store.dispatch('FedLogOut').then(() => {
            this.$router.replace({
              path: '/login',
            })
          })
        })
        .catch(() => {})
    },
    Comingsoon() {
      this.$message({
        message: 'Coming soon',
        type: 'warning',
        showClose: true,
      })
    },
    mapitme(item) {
      if (item.children.length > 0) {
        return item.children.find((i) => {
          return i.name == this.active
        })
      } else {
        return this.active == item.name
      }
    },
    updateActiveItem() {
      this.active = this.$route.name
    },
    changeitem(item, $evnet) {
      if (item.children.length > 0) {
        if (item.name) this.active = item.name
      } else {
        if (item.name) this.active = item.name
      }
      if (item.query) {
        this.$router.push({ name: item.name, query: { type: item.query } })
      } else {
        this.$router.push({ name: item.name })
      }

      this.$nextTick((res) => {
        document.querySelectorAll('.children').forEach((element, index) => {
          element.style.maxHeight = null
        })
        let panel = document.querySelectorAll('.children_active')[0]
        if (panel) {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        }
      })
    },
    changechildren(item) {
      if (item.name == 'shop') {
        window.open(item.path)
        return
      }
      if (!item.name) {
        this.Comingsoon()
        return
      }
      this.active = item.name
      this.$router.push({ name: item.name, query: { type: item.query } })
    },
    changecreators(index) {
      this.list[index].active = !this.list[index].active
    },
  },
}
</script>

<style lang="scss" scoped>
.Copyright {
  margin-top: 1.25rem;
  padding-bottom: 1.67rem;
  width: 11.42rem;
  font-size: 0.83rem;
  color: #888888;
  line-height: 1.17rem;
  text-align: left;
}
.tooltip {
  margin-top: 1.25rem;
  display: flex;
  padding-bottom: 1.67rem;
  border-bottom: 0.08rem solid #313342;
}
.logout {
  margin: 0;
  padding-top: 0.5rem;
  margin-bottom: 6rem !important;
}
.item {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  &_title {
    box-sizing: border-box;
    width: 14.56rem;
    height: 2.75rem;
    border-radius: 0.25rem;
    padding-left: 1.5rem;
    span:nth-child(1) {
      font-size: 1.5rem;
      margin-right: 1rem;
    }
    span {
      font-size: 1rem;
      color: #666666;
      // text-align: right;
    }
  }

  &_title_ac {
    background: #b4926e2a;
    border-radius: 0.25rem;
    span {
      color: #b4926e;
    }
    .iconleft1 {
      // transition: all 0.2s ease-out;
      // rotate: 90deg;
      display: inherit;
    }
    .iconleft {
      display: none;
    }
  }
  &_title:hover {
    background: #b4926e2a;
    border-radius: 0.25rem;
    span {
      color: #b4926e;
    }
    .iconleft1 {
      display: inherit;
    }
    .iconleft {
      display: none;
    }
  }
  .children {
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
    &_active {
      // max-height: 100%;

      height: 100%;
    }
    &_item {
      display: flex;
      align-items: center;
      height: 2.75rem;
      width: 12.13rem;
      margin-top: 0.5rem;
      text-align: left;
      margin-left: 1.5rem;
      &_icon {
        flex-shrink: 0;
        background: #666666;
        width: 0.75rem;
        height: 0.75rem;
        border-radius: 50%;
        margin-right: 1rem;
        margin-left: 1.5rem;
        &_ac {
          background: #b4926e;
        }
      }
      &:hover {
        span {
          color: #b4926e;
        }
        .children_item_icon {
          background: #b4926e !important;
        }
      }

      span:nth-child(1) {
        font-size: 1.5rem;
        margin: 0 1rem;
      }
      span {
        font-size: 1rem;
      }
      &_active {
        background: #b4926e2a;
        border-radius: 0.25rem;
      }
    }
  }
  &_icon {
    width: 1.83rem;
    height: 1.75rem;
    margin-right: 1rem;
  }
}
.item:last-child {
  border-bottom: none;
}
.sidebar {
  position: relative;
  width: 16.06rem;
}
::-webkit-scrollbar {
  display: none;
}
.content {
  position: fixed;
  width: 16.06rem;
  // height: calc(100vh - 5rem);
  height: 100%;
  overflow-y: auto;
  background: #ffffff;
  box-sizing: border-box;
  padding: 0 0.75rem;
  display: flex;
  flex-direction: column;
}
.creators {
  margin-left: auto;
  width: 0.67rem;
  rotate: -90deg;
  &_active {
    rotate: 90deg;
  }
}

.active {
  color: #b4926e !important;
}
.title1 {
  margin: 0.5rem 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding-left: 1.27rem;
  width: 14.56rem;
  height: 2.75rem;
  font-weight: 600;
  font-size: 1rem;
  color: #2c2c2c;
  line-height: 1.38rem;
}
.iconleft {
  font-size: 1.5rem;
}
.iconleft1 {
  font-size: 1.5rem;
  display: none;
}
.line {
  box-sizing: border-box;
  margin: 0.5rem 0.88rem 0;
  height: 1px;
  background: #f3f4f7;
}
</style>
